import { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
// import { Form } from 'react-bootstrap'
import styles from './style.module.scss'
import formStyles from '@assets/scss/components/form.module.scss'
import CustomFormGroup from '@shared/components/customForm/customFormGroup'
import MyImage from '@shared/components/myImage'
import darkModeImg from '@assets/images/icon/darkModeNew.svg'
import lightModeImg from '@assets/images/icon/lightModeNew.svg'
// import useTranslation from 'next-translate/useTranslation'
// import useWindowSize from '@shared/hooks/windowSize'
import GlobalEventsContext from '@shared/components/global-events/GlobalEventsContext'

function DarkModeButton({ isLightBg }) {
  // const { t } = useTranslation()
  // const [width] = useWindowSize()
  const [isDark, setDark] = useState(() => {
    return typeof window !== 'undefined' && window.localStorage.getItem('ot-theme')
  })
  const { dispatchGlobalEvents: editDarkModeEna } = useContext(GlobalEventsContext)

  useEffect(() => {
    setDark(window.localStorage.getItem('ot-theme') === 'dark')
  }, [])

  useEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]')
    if (isDark) {
      document.body.setAttribute('data-light-mode', 'false')
      metaThemeColor.setAttribute('content', '#121110')
      localStorage.setItem('ot-theme', 'dark')
      window.isDark = true
      editDarkModeEna({
        type: 'DARK_MODE',
        payload: { darkModeEna: 'dark' }
      })
    } else {
      document.body.setAttribute('data-light-mode', 'true')
      metaThemeColor.setAttribute('content', '#252775')
      localStorage.setItem('ot-theme', 'light')
      window.isDark = false
      editDarkModeEna({
        type: 'DARK_MODE',
        payload: { darkModeEna: 'light' }
      })
    }
  }, [isDark])

  function handleDark() {
    setDark(!isDark)
  }

  return (
    <CustomFormGroup className={`${formStyles.formSwitch} ${styles.cursorPointer} ${styles.modeSwitch} ${isLightBg && styles.darkSwitch} d-flex align-items-center ${isDark ? styles.dme : styles.lme}`} onClick={handleDark}>
      {/* {
        width < 992 && <Form.Switch.Label>{t('common:SwitchMode')}</Form.Switch.Label>
      } */}
      <div className={`${styles.switchMode} ${!isDark ? styles.lsb : styles.dsb}`}>
        {/* <Form.Switch type="switch" onChange={handleDark} checked={isDark} /> */}
        <div className={`${isDark ? styles.darkModeEnable : styles.lightModeEnable}`}>
          {
            isDark ? <MyImage src={lightModeImg} loading="lazy" alt="light mode" layout="responsive" width="22" height="22" /> : <MyImage src={darkModeImg} loading="lazy" alt="dark mode" layout="responsive" width="22" height="22" />
          }
        </div>
      </div>
    </CustomFormGroup>
  )
}
DarkModeButton.propTypes = {
  isLightBg: PropTypes.bool
}
export default DarkModeButton
